import firebase from "firebase";
import { User } from "@/entities/user";

export async function getLoginTutorsOfSchool(
  schoolDocId: string
): Promise<User[]> {
  const apiGetAllLoginTutors = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("get_all_login_tutors", { timeout: 60 * 1000 });
  const res = await apiGetAllLoginTutors({ schoolDocId });
  return res.data.users;
}

export async function changeUserEmail(
  uid: string,
  newEmail: string
): Promise<{ success: boolean; message: string }> {
  const apiChangeUserEmail = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("change_user_email", { timeout: 60 * 1000 });
  const res = await apiChangeUserEmail({ uid, newEmail });
  return res.data;
}
